
import recaptchaLoader from '~/services/recaptchaLoader';

export default {
    name: 'InlineRecaptcha',
    mounted() {
        this.$nextTick(() => {
            if (process.env.NODE_ENV === 'production') {
                recaptchaLoader(this.$store, () => {
                    this.initRecaptcha();
                });

                if (this.$store.state.recaptcha.isReady) {
                    this.initRecaptcha();
                }
            }
        });
    },
    methods: {
        initRecaptcha() {
            const key = this.$config.reCAPTCHA_site_key;

            /* global grecaptcha */
            grecaptcha.ready(() => {
                const clientId = grecaptcha.render('grecaptcha-inline', {
                    sitekey: key,
                    badge: 'inline',
                    size: 'invisible',
                });

                grecaptcha.execute(clientId, { action: 'register' }).then((token) => {
                    this.$emit('set-recaptcha', token);
                });
            });
        },
    },
};
